import React, { useEffect } from "react";
import { Col, Container, Form, Row, Tab, Tabs } from "react-bootstrap";
import style from "../form.module.scss";
import { useKPIs } from "../../../context/KPIsContext";
import { TODIS_FORM_FIELD } from "../../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { TODIS_BTN_SECUNDARY } from "../../../components/Buttons";
import { BsArrowClockwise } from "react-icons/bs";

const IWW_PORTS_IMP_PM_KPI = ({ data, changeValues, filter, showModalCalRange }) => {

    const { setValues, values, calculoPromedio, calculoYesNo, calculoPeriod, calculoPerType, calculoPerTypeStatus, calculoFundingSources } = useKPIs();

    useEffect(() => {
        setValues(prev => {
            return data
        })
    }, [data])

    useEffect(() => {
        calculateKPI()
    }, [values])

    const calculateKPI = () => {

        const datas = {
            project_type: {
                infrastructure: calculoPerType('type_foreseen_interven', 'infrastructure', filter.yearInit),
                reconstruction: calculoPerType('type_foreseen_interven', 'reconstruction', filter.yearInit),
                maintenances: calculoPerType('type_foreseen_interven', 'maintenances', filter.yearInit),
                horizontal: calculoPerType('type_foreseen_interven', 'horizontal', filter.yearInit)
            },
            TEN_TIndicators: {
                clean_fuels: calculoYesNo('clean_fuels_avail', filter.yearInit),
                terminal_avail: calculoYesNo('terminal_avail', filter.yearInit),
                rail_conn: calculoYesNo('rail_conn', filter.yearInit),
                cemt_conn: calculoYesNo('cmt_conn', filter.yearInit),
                ris_deploy: calculoYesNo('ris_deploy', filter.yearInit)
            },
            TEN_TCompliance: {
                rail_conn: {
                    bef_rail_conn: calculoYesNo('bef_rail_conn', filter.yearInit),
                    aft_rail_conn: calculoYesNo('aft_rail_conn', filter.yearInit)
                },
                cmt_conn: {
                    bef_cmt_conn: calculoYesNo('bef_cmt_conn', filter.yearInit),
                    aft_cmt_conn: calculoYesNo('aft_cmt_conn', filter.yearInit)
                },
                clean_fuels: {
                    bef_clean_fuels: calculoYesNo('bef_clean_fuels', filter.yearInit),
                    aft_clean_fuels: calculoYesNo('aft_clean_fuels', filter.yearInit)
                },
                terminal_avail: {
                    bef_terminal_avail: calculoYesNo('bef_terminal_avail', filter.yearInit),
                    aft_terminal_avail: calculoYesNo('aft_terminal_avail', filter.yearInit)
                },
                ris_deploy: {
                    bef_ris_deploy: calculoYesNo('bef_ris_deploy', filter.yearInit),
                    aft_ris_deploy: calculoYesNo('aft_ris_deploy', filter.yearInit)
                }
            },
            project_status: {
                status_high_level: {
                    implemented: calculoPerTypeStatus('implemented', filter.yearInit),
                    ongoing_proj_fs: calculoPerTypeStatus('ongoing_proj_fs', filter.yearInit),
                    mature_proj_fs: calculoPerTypeStatus('mature_proj_fs', filter.yearInit),
                    proj_under_prep: calculoPerTypeStatus('proj_under_prep', filter.yearInit)
                },
                status_detailed: {
                    implemented: calculoPerTypeStatus('implemented', filter.yearInit),
                    ongoing_proj_fs: {
                        workCur: calculoPerType('ongoing_proj_fs', 'workCur', filter.yearInit),
                        tenderWork: calculoPerType('ongoing_proj_fs', 'tenderWork', filter.yearInit),
                        designTender: calculoPerType('ongoing_proj_fs', 'designTender', filter.yearInit),
                        tenderOngoing: calculoPerType('ongoing_proj_fs', 'tenderOngoing', filter.yearInit),
                    },
                    mature_proj_fs: {
                        finOngoing: calculoPerType('mature_proj_fs', 'finOngoing', filter.yearInit),
                        finProceduresNotyetStarted: calculoPerType('mature_proj_fs', 'finProceduresNotyetStarted', filter.yearInit),
                        finSourceNotInd: calculoPerType('mature_proj_fs', 'finSourceNotInd', filter.yearInit)
                    },
                    proj_under_prep: {
                        feasOnGoing: calculoPerType('proj_under_prep', 'feasOnGoing', filter.yearInit),
                        feasUnderTen: calculoPerType('proj_under_prep', 'feasUnderTen', filter.yearInit),
                        financing: calculoPerType('proj_under_prep', 'financing', filter.yearInit)
                    }
                }
            },
            project_funding: {
                funding_source: {
                    proj_fund_nat_budg: calculoFundingSources('proj_fund_nat_budg', filter.yearInit),
                    proj_fund_wb: calculoFundingSources('proj_fund_wb', filter.yearInit),
                    proj_fund_ebrd: calculoFundingSources('proj_fund_ebrd', filter.yearInit),
                    proj_fund_eib: calculoFundingSources('proj_fund_eib', filter.yearInit),
                    other_ifi: calculoFundingSources('other_ifi', filter.yearInit),
                    concessions: calculoFundingSources('concessions', filter.yearInit),
                    eu_fund: calculoFundingSources('eu_fund', filter.yearInit),
                    other_fund: calculoFundingSources('other_fund', filter.yearInit)
                },
                capex: "" // TODO: CONSULTAR CAMPO
            },
            performance_indicators: {
                const_period: calculoPeriod('actual_const_period', 'forecast_const_period', filter.yearInit),
                capex: calculoPeriod('actual_capex', 'forecast_capex', filter.yearInit),
                opex: calculoPeriod('actual_opex', 'forecast_opex', filter.yearInit),
                maint_cost: calculoPeriod('actual_maint_cost', 'forecast_maint_cost', filter.yearInit),
                interest_during_const: calculoPromedio('interest_during_const', filter.yearInit),
                ebitda: "",
                revenue: calculoPeriod('actual_revenue', 'forecast_revenue', filter.yearInit),
                traffic_dev: {
                    port_traffic: calculoPeriod('actual_port_traffic', 'forecast_port_traffic', filter.yearInit),
                    pass_traffic: calculoPeriod('actual_pass_traffic', 'forecast_pass_traffic', filter.yearInit),
                    freight: calculoPeriod('actual_freight_tn', 'forecast_freight_tn', filter.yearInit)
                }
            }
        }

        changeValues(datas)
    }

    return (
        <Tabs defaultActiveKey="project_type" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="project_type" title="Project Type" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.infrastructure" label="New infrastructure (%)" name="project_type.infrastructure" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.reconstruction" label="Reconstruction/rehabilitation (%)" name="project_type.reconstruction" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.maintenances" label="Maintenance (%)" name="project_type.maintenances (%)" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.horizontal" label="Maintenance (%)" name="project_type.horizontal" disabled={true} />
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="TEN_TIndicators" title="Targeted TEN-T indicators" className={style.tabHeight} style={{ height: "66vh" }}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Percentage of projects per type of targeted TEN-T indicator</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="TEN_TIndicators.clean_fuels_avail" label="Clean fuels availability (%)" name="TEN_TIndicators.clean_fuels_avail" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="TEN_TIndicators.terminal_avail" label="Terminal availability (%)" name="TEN_TIndicators.terminal_avail" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="TEN_TIndicators.rail_conn" label="Rail Connection (%)" name="TEN_TIndicators.rail_conn" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="TEN_TIndicators.cmt_conn" label="CEMT Connection (%)" name="TEN_TIndicators.cmt_conn" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="TEN_TIndicators.ris_deploy" label="RIS Deploy (%)" name="TEN_TIndicators.ris_deploy" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="TEN_TCompliance" title="TEN-T Compliance" className={style.tabHeight} style={{ height: "66vh" }}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.rail_conn.bef_rail_conn" label="Rail connection compliance before the implementation of project(s) (%)" name="TEN_TCompliance.rail_conn.bef_rail_conn" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.rail_conn.aft_rail_conn" label="Rail connection compliance after the implementation of project(s) (%)" name="TEN_TCompliance.rail_conn.aft_rail_conn" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.cmt_conn.bef_cmt_conn" label="CEMT Connection compliance before the implementation of project(s) (%)" name="TEN_TCompliance.cmt_conn.bef_cmt_conn" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.cmt_conn.aft_cmt_conn" label="CEMT Connection compliance after the implementation of project(s) (%)" name="TEN_TCompliance.cmt_conn.aft_cmt_conn" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.clean_fuels.bef_clean_fuels" label="Clean fuels availability before the implementation of project(s) (%)" name="TEN_TCompliance.clean_fuels.bef_clean_fuels" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.clean_fuels.aft_clean_fuels" label="Clean fuels availability after the implementation of project(s) (%)" name="TEN_TCompliance.clean_fuels.aft_clean_fuels" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.terminal_avail.bef_terminal_avail" label="Terminal availability before the implementation of project(s) (%)" name="TEN_TCompliance.terminal_avail.bef_terminal_avail" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.terminal_avail.aft_terminal_avail" label="Terminal availability after the implementation of project(s) (%)" name="TEN_TCompliance.terminal_avail.aft_terminal_avail" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.ris_deploy.bef_ris_deploy" label="RIS deployment before the implementation of project(s) (%)" name="TEN_TCompliance.ris_deploy.bef_ris_deploy" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.ris_deploy.aft_ris_deploy" label="RIS deployment before the implementation of project(s) (%)" name="TEN_TCompliance.ris_deploy.aft_ris_deploy" disabled={true} />
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {/* <Tab eventKey="project_status" title="Project Status" className={style.tabHeight} style={{height: "66vh"}}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Status (high level)</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.implemented" label="% Implemented" name="project_status.status_high_level.implemented" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.ongoing_proj_fs" label="% On-going project (funding secured)" name="project_status.status_high_level.ongoing_proj_fs" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.mature_proj_fs" label="% Mature project (feasibility study ready, funding secured)" name="project_status.status_high_level.mature_proj_fs" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.proj_under_prep" label="% Project under preparation" name="project_status.status_high_level.proj_under_prep" disabled={true}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Status (detailed)</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_detailed.implemented" label="% Implemented" name="project_status.status_detailed.implemented" disabled={true}/>
                                </Col>
                                <Col lg={12}>
                                    <div style={{borderBottom: "3px solid #004494"}}>
                                        <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>On-going project (funding secured)</Form.Label>
                                    </div>
                                    <Row style={{paddingTop: "15px"}}>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.workCur" label="% Works currently under execution" name="project_status.status_detailed.ongoing_proj_fs.workCur" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.tenderWork" label="% Tender for works/design-build on-going" name="project_status.status_detailed.ongoing_proj_fs.tenderWork" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.designTender" label="% Design/Tender Dossier for DB under preparation" name="project_status.status_detailed.ongoing_proj_fs.designTender" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.tenderOngoing" label="% Tender for design on-going or about to be start" name="project_status.status_detailed.ongoing_proj_fs.tenderOngoing" disabled={true}/>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12}>
                                    <div style={{borderBottom: "3px solid #004494"}}>
                                        <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Mature project (feasibility study ready, funding secured)</Form.Label>
                                    </div>
                                    <Row style={{paddingTop: "15px"}}>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.mature_proj_fs.finOngoing" label="% Procedures on-going" name="project_status.status_detailed.mature_proj_fs.finOngoing" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.mature_proj_fs.finProceduresNotyetStarted" label="% Procedures not-yet-started" name="project_status.status_detailed.mature_proj_fs.finProceduresNotyetStarted" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.mature_proj_fs.finSourceNotInd" label="% Financing source not identified" name="project_status.status_detailed.mature_proj_fs.finSourceNotInd" disabled={true}/>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12}>
                                    <div style={{borderBottom: "3px solid #004494"}}>
                                        <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Project under preparation</Form.Label>
                                    </div>
                                    <Row style={{paddingTop: "15px"}}>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.proj_under_prep.feasOnGoing" label="% Feasibility study on-going" name="project_status.status_detailed.proj_under_prep.feasOnGoing" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.proj_under_prep.feasUnderTen" label="% Feasibility study under tendering" name="project_status.status_detailed.proj_under_prep.feasUnderTen" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.proj_under_prep.financing" label="% Procurement not yet started" name="project_status.status_detailed.proj_under_prep.financing" disabled={true}/>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab> */}
            <Tab eventKey="project_funding" title="Project Funding" className={style.tabHeight} style={{ height: "66vh" }}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Funding Sources</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_nat_budg" label="National Budget (%)" name="project_funding.funding_source.proj_fund_nat_budg" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_wb" label="World Bank (%)" name="project_funding.funding_source.proj_fund_wb" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_ebrd" label="European Bank for Reconstruction and Development (%)" name="project_funding.funding_source.proj_fund_ebrd" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_eib" label="European Investment Bank (%)" name="project_funding.funding_source.proj_fund_eib" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.other_ifi" label="Other International Financial Institutions (%)" name="project_funding.funding_source.other_ifi" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.concessions" label="Concessions (%)" name="project_funding.funding_source.concessions" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.eu_fund" label="EU Funds (%)" name="project_funding.funding_source.eu_fund" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.other_fund" label="Other funding source (%)" name="project_funding.funding_source.other_fund" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                        {/* <Col lg={5}>
                            <TODIS_FORM_FIELD id="project_funding.capex" label="CAPEX" name="project_funding.capex" disabled={true}/>
                        </Col> */}
                        {/* <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("project_funding.capex", "capex")}/>
                        </Col> */}
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="performance_indicators" title="Performance Indicators" className={style.tabHeight} style={{ height: "66vh" }}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.compl_date_deriv" label="Completion date deviation (no. of months)" name="performance_indicators.compl_date_deriv" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.const_period" label="Construction duration deviation (%)" name="performance_indicators.const_period" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.capex" label="CAPEX deviation (%)" name="performance_indicators.capex" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.opex" label="OPEX deviation (%)" name="performance_indicators.opex" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.maint_cost" label="Maintenance cost deviation (%)" name="performance_indicators.maint_cost" disabled={true} />
                        </Col>
                        {/* <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.interest_during_const" label="% Interest During Construction" name="performance_indicators.interest_during_const" disabled={true}/>
                        </Col> */}
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="performance_indicators.ebitda" label="EBITDA – last year (% of projects within user-defined ranges)" name="performance_indicators.ebitda" disabled={true} />
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{ fontSize: "12px", padding: "0.7rem 1rem" }} icon={BsArrowClockwise} onclick={() => showModalCalRange("performance_indicators.ebitda", "ebitda")} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.revenue" label="Revenue deviation - if fare/toll collected (%)" name="performance_indicators.revenue" disabled={true} />
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Throughput deviation (%)</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performance_indicators.traffic_dev.port_traffic" label="Port Throughput deviation (%)" name="performance_indicators.traffic_dev.port_traffic" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performance_indicators.traffic_dev.pass_traffic" label="Passenger traffic deviation (%)" name="performance_indicators.traffic_dev.pass_traffic" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performance_indicators.traffic_dev.freight" label="Freight (tn) deviation (%)" name="performance_indicators.traffic_dev.freight" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
        </Tabs>
    )
}

export default IWW_PORTS_IMP_PM_KPI;